export default __webpack_public_path__ + "static/media/ic3n.66faf4d8.jpg";